import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_REIMBURSEMENT_LIST: string = typeCreatorV2(
  'ReimbursmentsListReducer',
  'SetReimbursmentsList'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'ReimbursmentsListReducer',
  'SetUnreadNotificationCount'
);

export const SET_UPDATE_REIMBURSE_INFO: string = typeCreatorV2(
  'ReimbursmentsListReducer',
  'SetUpdateReimburseInfo'
);
